import { useState } from "react";
import { SourcesParams, SourcesRequest } from "@/services/backend/cpy/api/cpy";
import { CpyName } from "../types/entity-names";
import {
  CpySourcesTable,
  CpySourcesTableFilterOptions,
  CpySourcesTableFilters,
} from "./cpy-sources-table";

export function CpySources({
  destinationEntityName,
  destinationId,
  onCopySuccess,
  initialParams,
  ...props
}: {
  destinationEntityName: CpyName;
  destinationId: string;
  onCopySuccess?: () => void;
  initialParams?: SourcesParams;
} & CpySourcesTableFilterOptions) {
  const [request, setRequest] = useState<SourcesRequest>({
    destinationEntityName,
    params: initialParams || {
      orderBy: [{ field: "updatedAt", dsc: true }],
    },
  });

  return (
    <div className="grid gap-2">
      <CpySourcesTableFilters
        request={request}
        onRequestChange={setRequest}
        {...props}
      />
      <CpySourcesTable
        request={request}
        destinationId={destinationId}
        onCopySuccess={onCopySuccess}
      />
    </div>
  );
}
